<template>
  <page-outline>
    <template slot="pageContent">
      <alert-modal v-if="isAlertOpen && this.countNewVibans > 0">
        <span><i class="fa-solid fa-circle-check"></i>Exported {{ this.countExported }} records</span>
      </alert-modal>
      <div class='content bg-light'>
        <div>
          <b-container fluid>
            <!-- title -->
            <div class="content-title">
              <b-row>
                <h1>VIBAN Management</h1>
              </b-row>
              <b-row>
                <span>Manage virtual IBAN pool and allocations</span>
              </b-row>
            </div>
            <!-- data -->
            <b-row class="stats">
              <b-col @click="stat.status != null ? selectStatus(stat.status): ''" v-for="(stat, index) in stats" v-bind:key="index">
                <div>
                  <span :style="{color: stat.color}">{{ stat.number }}</span>
                  <span>{{ stat.title }}</span>
                </div>
              </b-col>
            </b-row>
          </b-container>

          <!-- flters -->
          <div class="filters">
            <b-row class="filters-items">
              <!-- Search -->
              <div class="filter-item">
                <span class="filter-item-title">Search VIBAN</span>
                <input type="text" class="filter-item-content" placeholder="Search by VIBAN or client number..." @input="event => (paginationObj.search = sanitize(event.target.value), submit())"  @keyup.enter="submit()"/>
              </div>
              <b-col>
                <!-- Status -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Status Filter</span>
                  <a id="status-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.status == null || this.paginationObj.status == "all" ? 'All Statuses' : statusList.filter(item => {
                        if(item.code == this.paginationObj.status){
                          return item
                        }
                    })[0].label}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                   <b-popover target="status-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(status, index) in statusList" :key="index" :class="['popover-option', {'popover-option-selected': status.code == 'all' ? paginationObj.status == null : status.code == paginationObj.status}]" @click="selectStatus(status.code)">
                        {{ status.label }}
                      </span>
                    </div>
                  </b-popover>
                </div>
                <!-- Country -->
                <div class="filter-item">
                  <span class="filter-item-title text-ellipsis">Country Filter</span>
                  <a id="country-picker-link"
                    class="filter-item-content d-flex justify-content-between py-2 px-3"
                    href="#">
                    <span class="fixed-span-size">
                      {{ this.paginationObj.country == null || this.paginationObj.country == "all" ? 'All Countries' : countryList.filter(item => {
                        if(item.code == this.paginationObj.country){
                          return item
                        }
                    })[0].label}}
                    </span>
                    <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                  </a>
                  <b-popover target="country-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                    <div>
                      <span v-for="(country, index) in countryList" :key="index" :class="['popover-option', {'popover-option-selected':  country.code == paginationObj.country}]" @click="selectCountry(country.code)">
                        {{ country.label }} {{ country.code != null ? '(' + country.code + ')' : '' }}
                      </span>
                    </div>
                  </b-popover>
                </div>
              </b-col>

              <!-- Pagination -->
              <div class="filter-item">
                <span class="filter-item-title text-ellipsis">Per Page</span>
                <a id="pagination-picker-link"
                  class="filter-item-content d-flex justify-content-between py-2 px-3"
                  href="#">
                  <span class="fixed-span-size">{{ this.paginationObj.maxResults }}</span>
                  <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
                </a>
                <b-popover target="pagination-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                  <div>
                    <span v-for="(resultsPerPage, index) in [10,20,30,40,50]" :key="index" :class="['popover-option', {'popover-option-selected':  resultsPerPage == paginationObj.maxResults}]" @click="selectPagination(resultsPerPage)">
                      {{ resultsPerPage }}
                    </span>
                  </div>
                </b-popover>
              </div>
            </b-row>
            <hr>
            <b-row style="display:flex; align-items:center; justify-content:space-between; padding-right:1rem;">
              <b-col>
                <span v-if="totalResultsFiltered > 0">Showing {{ paginationObj.firstIndex }} - {{
                  paginationObj.status != null || paginationObj.search != null || paginationObj.country != null ? (totalResultsFiltered < paginationObj.maxResults ? totalResultsFiltered : currentPage * paginationObj.maxResults )
                  :
                  (totalResults < paginationObj.maxResults ? totalResults : currentPage * paginationObj.maxResults )}} of {{ paginationObj.status != null || paginationObj.search != null || paginationObj.country != null ? totalResultsFiltered : totalResults }}
                  </span>
              </b-col>

              <div style="display:flex; align-items:center;  gap: 1rem;">
                <span class="selected" v-if="selectedItems.length > 0">{{ selectedItems.length }} selected</span>

                <button @click="clearSelection()" class="clear" v-if="selectedItems.length > 0"><i class="fa-classic fa-xmark"></i>Clear</button>

                <button @click="exportSelected()" v-if="selectedItems.length > 0"  class="btn-outline btn-tertiary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Selected ({{ selectedItems.length }})</button>

                <button @click="exportFiltered()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Filtered</button>

                <button @click="exportAll()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export All</button>

                <import-viban-modal @update:refresh="this.refresh"></import-viban-modal>

                <allocate-viban-modal @update:refresh="this.refresh"></allocate-viban-modal>

                <button @click="refresh()" class="btn-outline btn-dark">
                  <i :class="['fa-classic', 'fa-arrows-rotate', { 'rotate': isLoading }]"></i>
                  Refresh
                </button>
              </div>
            </b-row>
          </div>
          
          <!-- VIBANs list -->
          <div v-if="items != null" class="card">
            <div class="p-6">
              <h2>VIBAN Pool</h2>
              <span>{{ totalResults }} VIBAN{{ totalResults> 1 ? 's':'' }}</span>
            </div>
            <hr>
            <div v-if="totalResultsFiltered > 0" style="overflow-x:auto">
              <b-table responsive
                class="table-header-border"
                style="margin-bottom:0;"
                :items="items"
                :fields="fields"
                primary-key="id"
              >
              
                <template #head(checkbox)>
                  <label class="custom-checkbox">
                    <input type="checkbox" 
                      id="all" 
                      name="checkAll"
                      @change="selectAll($event)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #head(VIBAN)>
                  <span>Virtual IBAN
                    <a id="info-viban-link" href="#">
                      <i class="fa-light fa-circle-question"></i>
                    </a>
                  </span>
                  <b-popover target="info-viban-link" triggers="hover" placement="bottom" custom-class="popover-info">
                    <div>Virtual IBAN (VIBAN)</div>
                    <span>A unique virtual account number allocated to a client number. All orders from the same client use the same VIBAN for payment routing and automatic reconciliation.</span>
                  </b-popover>
                </template>

                <template #head(status)>
                  <span>Status
                    <a id="info-status-link" href="#"><i class="fa-light fa-circle-question"></i></a>
                  </span>
                  <b-popover target="info-status-link" triggers="hover" placement="bottom" custom-class="popover-info">
                    <div>VIBAN Status</div>
                    <span>Available: Ready for allocation. Allocated: In active use by a client. Deactivated: No longer in use but preserved for history.</span>
                  </b-popover>
                </template>

                <template #head(allocationdate)>
                  <span @click="toggleOrder()">Allocation Date <i :class="['fa-regular', {'fa-chevron-down': paginationObj.sortOrder == 'asc','fa-chevron-up': paginationObj.sortOrder == 'desc' || paginationObj.sortOrder == null}]"></i></span>
                </template>

                <template #cell(checkbox)="data">
                  <label class="custom-checkbox">
                    <input type="checkbox"
                          :value="data.item"
                          @change="toggleSelection($event, data.item)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(country)="data">
                  <span class="btn-empty">{{ data.item.VIBAN.substring(0, 2) }}</span> 
                </template>

                <template #cell(status)="data">
                  <button style="cursor: default;" v-if="data.item.Status == 0" :style="{color:'#008236','background-color':'#f0fdf4','border-color':'#b9f8cf'}" class="btn-tertiary-full">Available</button>
                  <button style="cursor: default;" v-else-if="data.item.Status == 1" class="btn-tertiary-full">Assigned</button>
                  <button style="cursor: default;" v-else class="btn-tertiary-full" :style="{color:'#c10007','background-color':'#fef2f2','border-color':'#ffc9c9'}">Frozen</button>
                </template>

                <template #cell(clientnumber)="data">
                  <span v-if="data.item.Reference1 != ''">{{ data.item.Reference1 }}</span>
                  <span v-else style="font-weight: normal;">—</span>
                </template>

                <template #cell(allocationdate)="data">
                  <div v-if="data.item.Date != ''">{{new Date(Date.parse(data.item.Date )).toLocaleDateString("fr")}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.Date != ''">{{new Date(Date.parse(data.item.Date )).toLocaleTimeString("it-IT")}}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(actions)="data">
                  <div class="d-flex" style="gap: 0.5rem; justify-content: center;">
                    <button
                      v-if="Number(data.item.Status) === 1"
                      @click="deallocateViban(data.item.IdGroup)"
                      :id="`deallocate-link-${data.index}`"
                      class="btn-outline-light"
                    >
                      <i class="fa-regular fa-unlock"></i>
                    </button>

                    <b-popover
                      v-if="Number(data.item.Status) === 1"
                      :target="`deallocate-link-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      Deallocate VIBAN
                    </b-popover>

                    <!-- Freeze / Unfreeze -->
                    <button
                      @click="updateStatus(
                        data.item.VIBAN,
                        Number(data.item.Status) === 2 ? 0 : 1
                      )"
                      :id="`freeze-link-${data.index}`"
                      class="btn-outline-light"
                    >
                      <i
                        :class="[
                          'fa-regular',
                          data.item.Status === 2 ? 'fa-unlock' : 'fa-lock'
                        ]"
                      ></i>
                    </button>

                    <b-popover
                      :target="`freeze-link-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      {{ Number(data.item.Status) === 2 ? 'Unfreeze VIBAN' : 'Freeze VIBAN' }}
                    </b-popover>

                    <!-- Transactions -->
                    <button
                      :id="`transaction-link-${data.index}`"
                      class="btn-outline-light"
                      title="View Transactions"
                      @click="navigate('/transactionledger/'+data.item.VIBAN)"
                    >
                      <i class="fa-regular fa-arrow-up-right-from-square"></i>
                    </button>

                    <b-popover
                      :target="`transaction-link-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      View Transactions
                    </b-popover>
                  </div>
                </template>

              </b-table>
              <hr>
            </div>
            <b-row v-if="totalResultsFiltered > 0" class="pagination">
              
              <button @click="currentPage > 1 && previous()" :class="['btn-outline-light btn', {inactive: currentPage == 1}]">Previous</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button @click="currentPage < totalPages && next()" :class="['btn-outline-light btn', {inactive: currentPage == totalPages}]">Next</button>
            </b-row>
            <div v-else style="margin: 1rem; color: #969696; display: flex; justify-content: center;">
              <span>No results found</span>
            </div>
          </div>
          <div v-else class="card empty">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </template>
  </page-outline>
</template>
<script>
import PageOutline from '@/components/common/PageOutline.vue'
import moment from 'moment'
import allocateVIBANModal from '@/components/common/allocateVIBANModal.vue'
import GenerateVIBANModal from '@/components/common/generateVIBANModal.vue'
import ImportVIBANModal from '@/components/common/importVIBANModal.vue'
import AlertModal from '../../components/common/alertModal.vue'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'VIBANManagement',
  components: {
    'page-outline': PageOutline,
    'allocate-viban-modal': allocateVIBANModal,
    'generate-viban-modal': GenerateVIBANModal,
    'import-viban-modal': ImportVIBANModal,
    AlertModal
  },
  data(){
    return {
      fields: [
        { key: 'checkbox', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle'},
        { key: 'VIBAN', label: 'Virtual IBAN', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'country', label: 'Country', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'status', label: 'Status', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left'},
        { key: 'clientNumber', label: 'Client Number', thClass: 'text-left align-middle border-bottom', tdClass: 'align-middle text-left font-weight-bold'},
        { key: 'AllocationDate', label: 'Allocation Date', thClass: 'text-left align-middle border-bottom text-nowrap', tdClass: 'align-middle text-left'},
        { key: 'actions', label: 'Actions', thClass: 'text-center align-middle border-bottom', tdClass: 'text-center align-middle' }
      ],
      items: null,
      countryList: [
        {
          label: "All Countries",
          code: null
        },
        {
          label: "France",
          code: "FR"
        },
        {
          label: "Germany",
          code: "DE"
        },
        {
          label: "Spain",
          code: "ES"
        },
        {
          label: "UK",
          code: "GB"
        },
        {
          label: "Belgium",
          code: "BE"
        },
        {
          label: "Italy",
          code: "IT"
        }
      ],
      statusList: [
        {
          label: "All Statuses",
          code: "all"
        },
        {
          label: "Available",
          code: 0
        },
        {
          label: "Assigned",
          code: 1
        },
        {
          label: "Frozen",
          code: 2
        }
      ],
      stats : [
        {
          "title":"Total VIBANs",
          "number": 0,
          "color": "#2b7fff",
          "status": "all"
        },
        {
          "title":"Available",
          "number": 0,
          "color": "#009966",
          "status": 0
        },
        {
          "title":"Assigned",
          "number": 0,
          "color": "#f54a00",
          "status": 1
        },
        {
          "title":"Frozen",
          "number": 0,
          "color": "#e7000b",
          "status": 2
        },
        {
          "title":"Utilization",
          "number": '0%',
          "color": "#9810fa"
        }
      ],
      paginationObj: {
        firstIndex: 1,
        maxResults : 10,
        sortOrder: null,
        search : null,
        status: null,
        country : null
      },
      currentPage: 1,
      totalPages: 0,
      selectedItems: [],
      isSidebarOpen: true,
      isLoading: false,
      totalResults: null,
      totalResultsFiltered: null,
      totalVibanAvailable: null,
      totalVibanAssigned: null,
      isAlertOpen: false,
      countExported: 0
    }
  },
  created(){
    this.$engine.services.payments.getGroups(this.paginationObj)
    .then(resp => {
      const data = resp.data
      this.items = data.references

      this.totalResults = data.nbTotalResults
      this.totalResultsFiltered = data.nbTotalResultsFiltered
      this.totalVibanAvailable = data.nbVibanFree
      this.totalVibanAssigned = data.nbVibanAssigned

      const total = this.totalResults
      const totalAvailable = this.totalVibanAvailable
      const totalAssigned = this.totalVibanAssigned
      const totalFrozen = total - totalAvailable - totalAssigned

      this.stats[0].number = total
      this.stats[1].number = totalAvailable
      this.stats[2].number = totalAssigned
      this.stats[3].number = totalFrozen
      this.stats[4].number = Math.round((totalAssigned * 100) / total) + '%'

      this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
    })
    .catch(err => {
      console.log(err)
    })
  },
  methods: {
    previous (){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex - this.paginationObj.maxResults
      this.currentPage--
      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references;
      })
      .catch(err => {
        console.log(err)
      })
    },
    next (){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex + this.paginationObj.maxResults
      this.currentPage++
      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references;
      })
      .catch(err => {
        console.log(err)
      })
    },
    navigate(url){
      loadPage(this, {url: url})
    },
    submit (){
      this.paginationObj.firstIndex = 1;
      this.currentPage = 1;

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResults = data.nbTotalResults
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalVibanAvailable = data.nbVibanFree
        this.totalVibanAssigned = data.nbVibanAssigned

        const total = this.totalResults
        const totalAvailable = this.totalVibanAvailable
        const totalAssigned = this.totalVibanAssigned
        const totalFrozen = total - totalAvailable - totalAssigned

        this.stats[0].number = total
        this.stats[1].number = totalAvailable
        this.stats[2].number = totalAssigned
        this.stats[3].number = totalFrozen
        this.stats[4].number = Math.round((totalAssigned * 100) / total) + '%'

        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
      })
      .catch(err => {
        console.log(err)
      })
    },
    toggleOrder (){
      this.paginationObj.sortOrder = this.paginationObj.sortOrder == 'asc' ? 'desc' : 'asc';

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })

    },
    toggleSelection (event, value) {
      const checked = event.target.checked;

      if (checked) {
        if (!this.selectedItems.some(item => item.VIBAN == value.VIBAN)) {
          this.selectedItems.push(value)
        }
      } else {
        const checkbox = document.querySelectorAll('input[type="checkbox"]')[0]
        if(checkbox.checked){
          checkbox.checked = false
        }
        this.selectedItems = this.selectedItems.filter(item => item.VIBAN !== value.VIBAN);
      }
    },
    selectAll (event){
      const checked = event.target.checked;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      if (checked) {
        checkboxes.forEach(item => item.checked = true)
        this.selectedItems = [...this.items];
      } else {
        this.selectedItems = []
        checkboxes.forEach(item => item.checked = false)
      }
    },
    clearSelection () {
      this.selectedItems = []
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      checkboxes.forEach(item => item.checked = false)
    },
    selectStatus (status){
      this.paginationObj.status = status == "all" ? null : status
      this.paginationObj.firstIndex = 1

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResults = data.nbTotalResults
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectCountry (code){
      this.paginationObj.country = code

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectPagination (resultsPerPage){
      this.paginationObj.maxResults = resultsPerPage
      this.paginationObj.firstIndex = 1

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResultsFiltered = data.nbTotalResultsFiltered
        this.totalPages = Math.ceil(data.nbTotalResultsFiltered/this.paginationObj.maxResults)
        this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    exportCSV (filters){
      this.$engine.services.payments.getGroups(filters)
      .then(resp => {
        const vibanData = resp
        let firstLine = 'Virtual IBAN' + ';' +
          'Country' + ';' +
          'Status' + ';' +
          'Client Number' + ';' +
          'Allocation Date' + ';' +
          'Total Volume' + '\r\n'

        let line = ''

        vibanData.data.references.forEach(item => {
          line += item.VIBAN + ';' +
          item.VIBAN.slice(0,2) + ';' + (item.Status == 0 ? 'Available' : item.Status == 1 ? 'Assigned' : 'Frozen') + ';' + item.Reference1 + ';' + (item.Date != "" ? new Date(Date.parse(item.Date )).toLocaleDateString("fr") : ' ' )  + ';' + item.Amount.toFixed(2)+ '\r\n'
        })

        let data = firstLine + line
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = 'vibans_' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        this.isAlertOpen = true;
        this.countExported = vibanData.data.references.length
        setTimeout(()=>{
          this.isAlertOpen = false;
          this.countExported = 0
        }, 3000)
      })
      .catch(err => {
        console.log(err)
      })
    },
    exportAll () {
      this.exportCSV({})
    },
    exportFiltered () {
      this.exportCSV({
        firstIndex: 1,
        sortOrder: this.paginationObj.sortOrder,
        search : this.paginationObj.search,
        status: this.paginationObj.status,
        country : this.paginationObj.country,
      })
    },
    exportSelected (){
      const selection = [...this.selectedItems];
      let firstLine = 'Virtual IBAN' + ';' +
        'Country' + ';' +
        'Status' + ';' +
        'Client Number' + ';' +
        'Allocation Date' + ';' +
        'Total Volume' + '\r\n'

      let line = ''

      selection.forEach(item => {
        line += item.VIBAN + ';' +
        item.VIBAN.slice(0,2) + ';' + (item.Status == 0 ? 'Available' : item.Status == 1 ? 'Assigned' : 'Frozen') + ';' + item.Reference1 + ';' + (item.Date != "" ? new Date(Date.parse(item.Date )).toLocaleDateString("fr") : ' ' )  + ';' + item.Amount.toFixed(2)+ '\r\n'
      })

      let data = firstLine + line
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'vibans_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
      this.isAlertOpen = true;
      this.countExported = selection.length
      setTimeout(()=>{
        this.isAlertOpen = false;
        this.countExported = 0
      }, 3000)
    },
    refresh (){
      if (this.isLoading) return;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.paginationObj = {
          firstIndex: 1,
          maxResults : 10,
          sortOrder: null,
          search : null,
          status: null,
          country : null,
        };
        this.submit()
      }, 800);
    },
    deallocateViban (IdGroup){
      this.$engine.services.payments.deleteGroup(IdGroup)
      .then(resp => {
        if(resp.status == 200){
          this.refresh();
        }
      })
    },
    updateStatus (viban, status){
      this.$engine.services.payments.updateGroup({'VIBAN': viban, 'freeze': status})
      .then(resp => {
        if(resp.status == 200){
          this.refresh();
        }
      })
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    }
  }
}
</script>
<style scoped>

.content-title{
  margin: 1.5rem 0rem;
}


.content-title>div>span{
  color: #000000a6;
  font-size: 1.1rem;
}

.table-header-border>table>thead>tr {
  border-bottom: 2px solid #0a0a0a;
}

.filter-item-content {
  width: 100% !important;
}

.actions {
  text-align: right;
  margin-top: 20px;
}

h3 {
  font-size: 1.125rem;
  font-weight: inherit;
}

.rotate {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.selected {
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  background-color: #dbeafe;
  color: #1d4ed8;
}

.clear{
  cursor: pointer;
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  border: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: transparent;
}

.clear:hover{
  background-color: #e9ebef;
}

.fa-circle-question, .fa-chevron-down, .fa-chevron-up{
  margin: 0rem 0.5rem;
  color: #99a1af;
}

.fa-circle-question:hover{
  color: #4a5565;
}

.pagination{
  display: flex;
  align-items: center;
  color: #000000a6;
  padding: 1rem 2rem;
}

table{
  width: 100%;
}

tr{
  padding: 1rem;
  height: 5rem;
}

tr:not(:first-child){
  border-top: 1px solid #0000001a;
}

td, th {
  font-weight: initial;
  padding: 1rem 1rem 1rem 2rem;
  white-space: nowrap;
}

th:nth-of-type(7){
  text-align: end;
}

td:nth-of-type(5){
  /* font-weight: bold; */
}

td:nth-of-type(7){
  /* font-weight: bold; */
  font-size: 1.25rem;
  text-align: end;
  color: #6a7282;
}

th:nth-of-type(8){
  text-align: center;
}

td:last-of-type{
  display: flex;
  gap: 0.2em;
  justify-content: end;
}

td:first-child, th:first-child{
  width: 6rem;
  padding: 1rem;
}

tr:hover{
  background-color: #f8f9fa;
}

.inactive{
  color: #0a0a0a;
  opacity: .5;;
  pointer-events: none;
  outline-style: none;
}

.filters{
  margin: 2rem 0rem;
}

.filters-container{
  width: 100%;
  margin: 2rem 0rem 0rem 0rem;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  background-color: #fff;
  padding: 2rem;
}

.filters-items{
  display: grid;
  grid-template-columns: 7fr 4fr 1fr;
  padding: 0rem 1rem;
}

.filters-items>div:nth-child(2){
  display: flex;
  gap: 1rem;
}

.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem 0rem;
}

.stats>div{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  padding: 0rem 1rem;
}

.stats>div:hover:not(:last-child){
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  cursor: pointer;
}

.stats>div>div{
  display: grid;
  row-gap: 1.5rem;
  color: #000000a6;
}

.stats>div>div>span:last-of-type{
font-size: 1rem;
}

.stats>div>div>span{
  font-size: 2rem;
  display: flex;
  justify-content: center;
}
</style>